import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ServiceMethods } from '@feathersjs/feathers';
import { Email } from 'src/app/models/email';
import { TableColumn } from '@noammazuz/vzn-data-table';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-email-table',
  templateUrl: './email-table.component.html',
  styleUrls: ['./email-table.component.scss']
})
export class EmailTableComponent implements OnInit {
  @ViewChild('sendEmailButtonTmpl', { static: true }) sendEmailButtonTmpl: ElementRef;
  sendEmailService: ServiceMethods<any>;
  emailService: ServiceMethods<Email>;
  query: any = {
    $sort: {
      createdAt: -1
    }
  };
  columns: TableColumn[];
  constructor(
    public translate: TranslateService,
    private feathers: VznFeathersService<Email>,
    private router: Router
  ) {
    this.translate=translate;
    this.emailService = this.feathers.service('emails');
    this.sendEmailService = this.feathers.service('send-email');
  }

  ngOnInit(): void {
    this.columns = [
      { prop: 'name', name: this.translate.instant('MAILERS.NAME'), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'subject', name: this.translate.instant('MAILERS.SUBJECT'), cellTemplate: 'textTmpl'},
      //{ prop: 'sendMail', name: 'אנשי קשר', customTemplate: this.sendEmailButtonTmpl},
    ];
  }

  emailMapper(rows: any[]) {
    return rows.map(row => new Email(row));
  }

  onDoubleClick(mailList: Email) {
    this.router.navigate([`/email-details/${mailList._id}`])
  }

  sendEmail(event: MouseEvent, email: Email) {
    event.preventDefault();
    event.stopImmediatePropagation();

    this.sendEmailService.create({
      emailId: email._id
    });
  }
}
